import { useEffect, useRef, useState } from "react";
import Bookmarks from "@arcgis/core/widgets/Bookmarks";


const BookmarksComponent = ({ mapView, visiblePanels }) => {
    var bookmarksRef = useRef(null);
    
    var [bookmarks, setBookmarks] = useState('');

    //tableVisible ? localStorage.getItem('sgvmap40_splitPos') ? parseInt(localStorage.getItem('sgvmap40_splitPos')) : "50%" : "100%"

    useEffect(() => {

        const BOOKMARK_KEY = 'arcgis-local-bookmarks' //clave del local storage

        let existingData = []; //variable que almacena los bookmarks y con la que se trabaja
        const existingBookmarks = localStorage.getItem(BOOKMARK_KEY) || null; //variable donde se guardan los bookmark cargados del localstorage

        //Componente bookmarks de la API esri
        const bookmarks = new Bookmarks({
            view: mapView,
            // allows bookmarks to be added, edited, or deleted
            editingEnabled: true,
            container: bookmarksRef.current,
            visibleElements: {
                time: false // don't show the time (h:m:s) next to the date
            }
        });

        /**
         * Si existen bookmarks en el localstorage entonces se añaden al componente bookmarks
         */
        if (existingBookmarks) {
            existingData = JSON.parse(existingBookmarks);
            existingData.forEach(element => {
                bookmarks.bookmarks.add(element)
            });
        }


        /**
         * Evento que se ejecuta con los cambios en los bookmarks.
         * 
         *  Si un bookmars es añadido entonces el nuevo bookmark se añade al array existingData
         *  Si un bookmars es eliminado entonces solo los otros bookmarks se añaden al array existingData
         * 
         * Por ultimo se actauliza el localStorage
         */
        bookmarks.bookmarks.on("change", function (bookmark) {

            bookmark.added.forEach(function (e) {
                existingData.push(e)
            });

            bookmark.removed.forEach(function (e) {

                const elements = existingData.filter(item => item.name != e.name)
                existingData = elements;

            });

            localStorage.setItem(BOOKMARK_KEY, JSON.stringify(existingData))
        });

        /**
         * Evento que se ejecuta cuando la view está ready
         * 
         *  Este evento se ejecuta cuando un bookmark es clicado. Funciones:
         *      Cambia la extent de la vista a la del bookmark
         *      Si se a clicado el bookmark para cambiar el nombre entonces se modifica el nombre del bookmark, se actualiza el array
         *      existingData y se actualiza el LocalStorage
         * 
         */
        mapView.when(function () {
            bookmarks.on("bookmark-select", (event) => {
                const nameOriginal = event.bookmark.name;

                mapView.extent = event.bookmark.extent

                event.bookmark.watch("name", function (name) {
                    existingData.map(item => item.name == nameOriginal ? item.name = name : item.name)
                    localStorage.removeItem(BOOKMARK_KEY)
                    localStorage.setItem(BOOKMARK_KEY, JSON.stringify(existingData))
                });
            });
        });

    }, [])

    return (
        <>
            <div ref={bookmarksRef} ></div>
        </>
    )
}

export default BookmarksComponent;